import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDetailsContainer from '../../../baseContainers/BaseDetailsContainer';
import {CustomMessages} from '../../../components/CustomMessages';
import InputDropdownComponent from '../../../components/inputs/InputDropdownComponent';
import InputTextComponent from '../../../components/inputs/InputTextComponent';
import AccountService from '../../../services/AccountService';
import InternalUserService from '../../../services/InternalUserService';
import AppPrefixUtils from '../../../utils/AppPrefixUtils';
import InputMultiSelectComponent from '../../../components/inputs/InputMultiSelectComponent';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';

class ProfileContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new InternalUserService());
        this.state = {
            viewMode: props.viewMode,
            newPassword: '',
            repeatPassword: '',
            element: {},
            showConfirmDialog: false,
            roles: [],
        };
        this.backLinkRendered = false;
        this.handleSendLinkToChangePassword = this.handleSendLinkToChangePassword.bind(this);
    }

    setElement() {
        this.blockUi();
        this.service
            .get(this.props.userId)
            .then((data) => {
                this.setState(
                    (prevState) => ({
                        element: {
                            ...prevState.element,
                            id: data.id,
                            email: data.email,
                            firstName: data?.firstName,
                            lastName: data?.lastName,
                            password: data.password,
                            roles: data.roles.enumValue,
                            status: data.status,
                            role: data.roles,
                        },
                    }),

                    () => this.initAfterSetElement(data)
                );
            })
            .catch((err) => {
                this.handleGetDetailsError(err);
                this.unblockUi();
            });
    }

    initAfterSetElement(data) {
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
            },
        }));
        this.unblockUi();
    }

    getUpdateSucces() {
        return t('profile.actualizedSuccess');
    }

    initBeforeSetElement() {
        // this.enumService
        //     .getEnumList('UserRoleType', this.translate)
        //     .then((roles) =>
        //         this.setState({
        //             roles,
        //         })
        //     )
        //     .catch(() => {
        //         this.props.showErrorMessage(t('user.error.getRoles'));
        //     });
    }

    prepareHeaderItems() {}

    prepareFooterItems() {
        const {detailUrl} = this.props;
        const viewMode = this.props.viewMode;
        const {editUrl} = this.props;
        const editHref = `${editUrl}/${this.state.element.id}`;

        return [
            {
                label: t('global.save'),
                className: 'float-left',
                onClick: this.handleFormSubmit,
                rendered: viewMode === 'NEW' || viewMode === 'EDIT',
            },
            {
                label: t('global.cancel'),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(detailUrl));
                },
                className: 'gray',
                rendered: viewMode === 'NEW' || viewMode === 'EDIT',
            },
            {
                label: t('global.edit'),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(editHref));
                },
                iconName: 'mdi-pencil',
                className: 'float-right',
                rendered: viewMode === 'VIEW',
            },
            {
                label: t('profile.changePassword'),
                onClick: this.handleSendLinkToChangePassword,
                variant: 'blue',
                className: 'float-right',
                rendered: viewMode === 'VIEW',
            },
        ];
    }

    handleFormSubmit() {
        if (this.validator.allValid()) {
            const {detailUrl} = this.props;
            const {element} = this.state;
            let successfullUrl = `${detailUrl}`;
            this.service
                .updateMyAccount(element)
                .then(() => {
                    //this.showSuccessMessage(this.getUpdateSucces());
                    this.persistMessage('success', '', this.getUpdateSucces());
                    // window.location.href = AppPrefixUtils.locationHrefUrl(successfullUrl);
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(successfullUrl));
                })
                .catch((err) => {
                    this.showErrorMessage(err.message);
                });
        } else {
            this.validator.showMessages();
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    handleSendLinkToChangePassword(e) {
        e.preventDefault();
        if (this.validator.allValid()) {
            const {detailUrl} = this.props;
            let successfullUrl = `${detailUrl}`;
            this.blockUi();
            new AccountService()
                .sendLinkForGenerateNewPassword(this.state.element.email)
                .then(() => {
                    // this.showSuccessMessage(this.getSentSucces());
                    this.unblockUi();
                    this.persistMessage('success', '', this.getSentSucces());
                    // window.location.href = AppPrefixUtils.locationHrefUrl(successfullUrl);
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(successfullUrl));
                })
                .catch((err) => {
                    this.showErrorMessage(err.message);
                    this.unblockUi();
                });
        } else {
            this.validator.showMessages();
            this.setState({
                valid: false,
            });
            this.forceUpdate();
        }
    }
    getSentSucces() {
        return t('password.resetSuccessLabel');
    }

    breadCrumbItems() {
        const secondBreadCrumb = this.props.viewMode === 'EDIT' ? 'profile.edit' : 'profile.details';
        return this.props.embedded
            ? [{name: t('profile.manageAccount'), url: '/manage-account/details'}]
            : [
                  {name: t('profile.manageAccount'), url: '/manage-account/details'},
                  {name: t(secondBreadCrumb), url: `/manage-account/edit/${this.state.element?.id}`},
              ];
    }

    render() {
        return (
            <React.Fragment>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} />
                <div className='container-fluid'>{this.renderView()}</div>
            </React.Fragment>
        );
    }
    getContainerListName() {
        return 'manage-account';
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    isClient() {}

    renderDetails() {
        return (
            <React.Fragment>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} />
                <div className='row'>
                    <React.Fragment>
                        <InputTextComponent
                            id='firstName'
                            name='firstName'
                            label={t('profile.name')}
                            colClass='col-md-4'
                            value={this.state.element?.firstName}
                            validator={this.validator}
                            validators='required|max:50'
                            onChange={this.handleChange}
                            viewMode={this.props.viewMode}
                        />
                        <InputTextComponent
                            id='lastName'
                            name='lastName'
                            label={t('profile.lastName')}
                            colClass='col-md-4'
                            value={this.state.element?.lastName}
                            validator={this.validator}
                            validators='required|max:50'
                            onChange={this.handleChange}
                            viewMode={this.props.viewMode}
                        />
                    </React.Fragment>

                    <React.Fragment>
                        <InputTextComponent
                            id='email'
                            name='email'
                            label={t('profile.email')}
                            colClass='col-md-4'
                            value={this.state.element.email}
                            validator={this.validator}
                            validators='required|email'
                            onChange={this.handleChange}
                            viewMode={'VIEW'}
                        />
                        <InputDropdownComponent
                            id='status'
                            name='status'
                            label={t('profile.status')}
                            colClass='col-md-4'
                            value={t(`status.${this.state.element.status}`)}
                            validator={this.validator}
                            options={this.state.statusOptions}
                            onChange={this.handleChange}
                            viewMode={'VIEW'}
                            optionLabel='label'
                            dataKey='value'
                        />
                        <InputMultiSelectComponent
                            id='roles'
                            name='roles'
                            colClass='col-md-6'
                            label={t('user.roles')}
                            value={this.state.element.role}
                            validator={this.validator}
                            validators={'required|array_required'}
                            onChange={this.handleChange}
                            viewMode={'VIEW'}
                            options={this.state.roles}
                            dataKey='enumValue'
                            optionLabel='label'
                            validateViewMode
                        />
                    </React.Fragment>
                </div>
            </React.Fragment>
        );
    }
}

ProfileContainer.defaultProps = {
    cancelUrl: '/manage-account/details',
    detailUrl: '/manage-account/details',
    editUrl: '/manage-account/edit',
    backUrl: null,
};

ProfileContainer.propTypes = {
    cancelUrl: PropTypes.string,
    detailUrl: PropTypes.string,
    editUrl: PropTypes.string,
    changePackageUrl: PropTypes.string,
};

export default withRouter(withTranslation()(ProfileContainer));
